module.exports = __webpack_public_path__ + "static/media/studiosBackground.cea22f4c.jpg";